import { responsiveVariables } from "../../utilities/props.js";
import "./aspectRatio.css";
const getAspectRatioStyles = (value) => {
    if (!value)
        return null;
    const variables = responsiveVariables("--rs-ratio", value);
    return { variables };
};
export default getAspectRatioStyles;
